// @flow
import React from 'react';
import classNames from 'classnames';
import { Image } from '../image/index';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  imageUrl: string,
  onClick: () => void,
  caption?: string,
  className?: string,
  thumbNail: string,
  isHoveredImagePresent: boolean,
  type?: string,
  description?: string,
};

export const ImageGalleryItem = (props: Props) => {
  const {
    imageUrl,
    caption = '',
    className = '',
    thumbnail,
    isHoveredImagePresent,
    type,
    description,
  } = props;
  // const isHovered = isHoveredImagePresent ? isHoveredImagePresent : false;
  const containerClass = classNames('image-gallery-item', className);
  return (
    <div className={containerClass} onClick={props.onClick}>
      <Image
        src={imageUrl}
        thumbNail={thumbnail}
        alt={'Gallery'}
        isHoveredImagePresent={true}
      />
      {type === 'architect-overlay-banner' && (
        <h1 className={'image-description'}>{description}</h1>
      )}
      {caption && <p>{caption}</p>}
    </div>
  );
};
